// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RhIU","content":"styles_content__3BmdG"};